<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card header="Parametri">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio">
                        

                        <b-row class="my-1">
                                <b-col sm="3"><label for="infonewapp">Info New App:</label></b-col>
                                <b-col sm="9">
                                    <b-input-group>
                                        <b-form-input v-model="parametri.infonewappVis" id="infonewapp" type="text" disabled></b-form-input>
                                        <b-input-group-append>
                                            <b-btn v-show="parametri.infonewappVis !== ''" variant="success" @click="visAllegato('infonewapp','IW')">Visualizza</b-btn>
                                            <b-btn variant="primary" @click="insertAllegato('infonewapp','IW')">Carica</b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            
                           <b-row class="my-1">
                                    <b-col sm="3"><label for="organigramma">Organigramma:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <!-- :formatter="formatPath" lazy-formatter -->
                                            <b-form-input v-model="parametri.organigrammaVis" id="organigramma" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <b-btn v-show="parametri.organigrammaVis !== ''" variant="success" @click="visAllegato('organigramma','CO')">Visualizza</b-btn>
                                                <b-btn variant="primary" @click="insertAllegato('organigramma','CO')">Carica</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>


                                <b-row class="my-1">
                                    <b-col sm="3"><label for="storia">Storia:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.storiaVis" id="storia" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <b-btn v-show="parametri.storiaVis !== ''" variant="success" @click="visAllegato('storia','CT')">Visualizza</b-btn>
                                                <b-btn variant="primary" @click="insertAllegato('storia','CT')">Carica</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>


                                <b-row class="my-1">
                                    <b-col sm="3"><label for="regolamento">Regolamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.regolamentoVis" id="regolamento" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <b-btn v-show="parametri.regolamentoVis !== ''" variant="success" @click="visAllegato('regolamento','CR')">Visualizza</b-btn>
                                                <b-btn variant="primary" @click="insertAllegato('regolamento','CR')">Carica</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>


                                <b-row class="my-1">
                                    <b-col sm="3"><label for="statuto">Statuto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.statutoVis" id="statuto" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <b-btn v-show="parametri.statutoVis !== ''" variant="success" @click="visAllegato('statuto','CS')">Visualizza</b-btn>
                                                <b-btn variant="primary" @click="insertAllegato('statuto','CS')">Carica</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="info">Info:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.infoVis" id="info" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <b-btn v-show="parametri.infoVis !== ''" variant="success" @click="visAllegato('info','CI')">Visualizza</b-btn>
                                                <b-btn variant="primary" @click="insertAllegato('info','CI')">Carica</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="contatti">Contatti:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.contattiVis" id="contatti" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <b-btn v-show="parametri.contattiVis !== ''" variant="success" @click="visAllegato('contatti','CN')">Visualizza</b-btn>
                                                <b-btn variant="primary" @click="insertAllegato('contatti','CN')">Carica</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="urlprivacypolicy">Url privacy policy:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.urlprivacypolicy" id="urlprivacypolicy" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('urlprivacypolicy', parametri.urlprivacypolicy)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

         <!--                        <b-row class="my-1">
                                    <b-col sm="3"><label for="background">Colore sfondo utenti:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.coloreutenti" id="coloreutenti" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('coloreutenti', parametri.coloreutenti)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

<!--                                <b-row class="my-1">
                                    <b-col sm="3"><label for="facebook">Facebook:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.facebook" id="facebook" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('facebook', parametri.facebook)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>-->

                                          <!-- <b-row class="my-1">
                                    <b-col sm="3"><label for="tw">Twitter:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.tw" id="tw" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('tw', parametri.tw)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="ig">Instagram:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.ig" id="ig" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('ig', parametri.ig)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="wa">WhatsApp:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.wa" id="wa" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('wa', parametri.wa)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="sitoweb">Sito web:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.sitoweb" id="sitoweb" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('sitoweb', parametri.sitoweb)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="ticket">Ticket:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.ticket" id="ticket" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('ticket', parametri.ticket)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="viaggi">Viaggi:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.viaggi" id="viaggi" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('viaggi', parametri.viaggi)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="servizi">Servizi:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.servizi" id="servizi" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('servizi', parametri.servizi)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="feedrss">FeedRSS:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.feedrss" id="feedrss" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('feedrss', parametri.feedrss)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                         <b-row class="my-1">
                                    <b-col sm="3"><label for="util1">Utility 1:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.util1" id="util1" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('util1', parametri.util1)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="util2">Utility 2:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.util2" id="util2" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('util2', parametri.util2)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="util3">Utility 3:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.util3" id="util3" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('util3', parametri.util3)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="util4">Utility 4:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.util4" id="util4" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('util4', parametri.util4)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="util5">Utility 5:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.util5" id="util5" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('util5', parametri.util5)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

                           <!--      <b-row class="my-1">
                                    <b-col sm="3"><label for="flgsocioattivodef">Socio attivo default:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgsocioattivodef" :options="options_socioattivodef" id="flgsocioattivodef">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgsocioattivodef', parametri.flgsocioattivodef)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgcfsocio">Codice fiscale socio obbligatorio:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgcfsocio" :options="options_flgcfsocio" id="flgcfsocio">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgcfsocio', parametri.flgcfsocio)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgcellsocio">Cellulare socio obbligatorio:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgcellsocio" :options="options_flgcellsocio" id="flgcellsocio">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgcellsocio', parametri.flgcellsocio)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgindsocio">Indirizzo socio obbligatorio:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgindsocio" :options="options_flgindsocio" id="flgindsocio">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgindsocio', parametri.flgindsocio)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgmodsociapp">Abilitazione modifica soci da App:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgmodsociapp" :options="options_flgmodsociapp" id="flgmodsociapp">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgmodsociapp', parametri.flgmodsociapp)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
 -->
                               <!--  <b-row class="my-1">
                                    <b-col sm="3"><label for="flgmodparentiapp">Abilitazione inserimento parenti da App:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgmodparentiapp" :options="options_flgmodparentiapp" id="flgmodparentiapp">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgmodparentiapp', parametri.flgmodparentiapp)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
 -->

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="durataautoscrollcarosello">Durata autoscroll carosello (> 0 in millisecondi):</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.durataautoscrollcarosello" id="durataautoscrollcarosello" type="number" 
                                                pattern="[0-9]*"
                                                step="1"
                                                min="1">
                                            </b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('durataautoscrollcarosello', parametri.durataautoscrollcarosello)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="durataanimazionecarosello">Durata animazione carosello (> 0 in millisecondi):</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.durataanimazionecarosello" id="durataanimazionecarosello" type="number" 
                                                pattern="[0-9]*"
                                                step="1"
                                                min="1">
                                            </b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('durataanimazionecarosello', parametri.durataanimazionecarosello)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgablfamiliari">Abilitazione accesso Familiari:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgablfamiliari" :options="options_flgablfamiliari" id="flgablfamiliari">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgablfamiliari', parametri.flgablfamiliari)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="flgeventigiornalieri">Abilitazione eventi giornalieri:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgeventigiornalieri" :options="options_eventigiornalieri" id="flgeventigiornalieri">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgeventigiornalieri', parametri.flgeventigiornalieri)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgdocumenti">Abilitazione documenti:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgdocumenti" :options="options_documenti" id="flgdocumenti">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgdocumenti', parametri.flgdocumenti)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgquestionari">Abilitazione questionari:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgquestionari" :options="options_questionari" id="flgquestionari">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgquestionari', parametri.flgquestionari)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="flgparenti">Abilitazione parenti:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgparenti" :options="options_parenti" id="flgparenti">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgparenti', parametri.flgparenti)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="flgabbonamenti">Abilitazione abbonamenti:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgabbonamenti" :options="options_abbonamenti" id="flgabbonamenti">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgabbonamenti', parametri.flgabbonamenti)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="flgpagamenti">Abilitazione pagamenti:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgpagamenti" :options="options_pagamenti" id="flgpagamenti">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgpagamenti', parametri.flgpagamenti)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="flgpreimplistpers1">Prenotazioni impianti lista personalizzata 1:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.flgpreimplistpers1" :options="options_flgpreimplistpers1" id="flgpreimplistpers1">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('flgpreimplistpers1', parametri.flgpreimplistpers1)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>



                                <b-row class="my-1">
                                    <b-col sm="3"><label for="labelorarinessuno">Etichetta prenotabilità orari "Nessuno":</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.labelorarinessuno" id="labelorarinessuno" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('labelorarinessuno', parametri.labelorarinessuno)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->
<!--
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="codfisiscrittoopt">Codice fiscale "Iscritto" opzionale:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-select v-model="parametri.codfisiscrittoopt" :options="options_codfisiscrittoopt" id="codfisiscrittoopt">

                                            </b-form-select>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('codfisiscrittoopt', parametri.codfisiscrittoopt)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

<!--                                 <b-row class="my-1" v-show="parametri.flgpagamenti == 'S'">
                                    <b-col sm="3"><label for="paypalapikey">PayPal API Key:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.paypalapikey" id="paypalapikey" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('paypalapikey', parametri.paypalapikey)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row> -->

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="verminappflutterandroid">Versione minima App Flutter Android (build):</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.verminappflutterandroid" id="verminappflutterandroid" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('verminappflutterandroid', parametri.verminappflutterandroid)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="verminappflutterios">Versione minima App Flutter iOS (build):</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.verminappflutterios" id="verminappflutterios" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('verminappflutterios', parametri.verminappflutterios)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="verminappandroid">Versione minima App Android (build):</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.verminappandroid" id="verminappandroid" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('verminappandroid', parametri.verminappandroid)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="verminappios">Versione minima App iOS (build):</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-input v-model="parametri.verminappios" id="verminappios" type="text"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('verminappios', parametri.verminappios)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="templatecardhtmlsocio">Template tessera socio HTML:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-textarea v-model="parametri.templatecardhtmlsocio" id="templatecardhtmlsocio"></b-form-textarea>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('templatecardhtmlsocio', parametri.templatecardhtmlsocio)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="templatecardhtmlfamiliare">Template tessera familiare HTML:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group>
                                            <b-form-textarea v-model="parametri.templatecardhtmlfamiliare" id="templatecardhtmlfamiliare"></b-form-textarea>
                                            <b-input-group-append>
                                                <b-btn variant="primary" @click="insert('templatecardhtmlfamiliare', parametri.templatecardhtmlfamiliare)">Salva</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component Upload -->
    <b-modal v-model="uploadModal.show" title="Seleziona il file da caricare" @hidden="onHidden">
        <!-- <p class="my-2">Seleziona il file da inserire</p> -->
        <b-btn id="browse" ref="browse" size="md" variant="primary">Sfoglia...</b-btn>
        <h5>{{uploadModal.descrCaricamento}}</h5>
        <b-progress v-if="uploadModal.showPercent" :value="uploadModal.percentCaricamento" max="100" show-progress animated></b-progress>
        <b-alert style="margin-top:10px;" :show="(uploadModal.errorCaricamento != '')" variant="danger">{{ uploadModal.errorCaricamento }}</b-alert>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="caricaItem()" style="margin: 2px;">
                Carica
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="uploadModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>

import {
    NAMESPACE,
    TOKENUPLOAD
} from '../config.js'

import {
    uuidv4
} from '../util.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Resumable
} from '../resumable.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            r: new Resumable({
                target: '',
                testChunks: true
            }),
            namespace: NAMESPACE,
            uploadModal: {
                show: false,
                descrCaricamento: '',
                showPercent: false,
                percentCaricamento: 0,
                errorCaricamento: '',
                uuidv4: '',
                item: '',
                tipo: ''
            },
            parametri: {
                id: null,
                facebook: '',
                urlprivacypolicy: '',
                coloreutenti: '',
                tw: '',
                ig: '',
                wa: '',
                util1: '',
                util2: '',
                util3: '',
                util4: '',
                util5: '',
                sitoweb: '',
                ticket: '',
                viaggi: '',
                servizi: '',
                feedrss: '',
                info: '',
                infonewapp: '',
                storia: '',
                statuto: '',
                organigramma: '',
                regolamento: '',
                contatti: '',
                infoVis: '',
                infonewappVis: '',
                storiaVis: '',
                statutoVis: '',
                organigrammaVis: '',
                regolamentoVis: '',
                contattiVis: '',
                flgpagamenti: 'N',
                paypalapikey: '',
                flgpreimplistpers1: 'N',
                flgeventigiornalieri: 'N',
                flgsocioattivodef: 'S',
                flgdocumenti: 'N',
                flgquestionari: 'S',
                flgparenti: 'N',
                flgabbonamenti: 'N',
                codfisiscrittoopt: 'N',
                verminappios: '',
                verminappandroid: '',
                verminappflutterandroid: '',
                verminappflutterios: '',
                templatecardhtmlsocio: '',
                templatecardhtmlfamiliare: '',
                flgcellsocio: 'N',
                flgindsocio: 'N',
                flgcfsocio: 'N',
                flgmodparentiapp: 'N',
                flgmodsociapp: 'N',
                flgablfamiliari: 'N',
                durataautoscrollcarosello: null,
                durataanimazionecarosello: null,
            },
            options_socioattivodef: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_codfisiscrittoopt: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgablfamiliari: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgpreimplistpers1: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_pagamenti: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_documenti: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_questionari: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_parenti: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_abbonamenti: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_modulistica: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_eventigiornalieri: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgcfsocio: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgindsocio: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgcellsocio: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgmodparentiapp: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgmodsociapp: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 5,
            dismissCountDown: 0
        };
    },
    methods: {
        //per vue bootstrap va messo qui nel caso di input
        //formatPath(value, event) {
        formatPath(value) {
            if (!value) return '';
            var split = value.split('/');
            return decodeURI(split[split.length - 1]);
        },
        onHidden(evt) {
            this.r.cancel();
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        setParametri(item) {
            var parametriAux = item;
            parametriAux.infoVis = this.formatPath(parametriAux.info);
            parametriAux.infonewappVis = this.formatPath(parametriAux.infonewapp);
            parametriAux.storiaVis = this.formatPath(parametriAux.storia);
            parametriAux.statutoVis = this.formatPath(parametriAux.statuto);
            parametriAux.organigrammaVis = this.formatPath(parametriAux.organigramma);
            parametriAux.regolamentoVis = this.formatPath(parametriAux.regolamento);
            parametriAux.contattiVis = this.formatPath(parametriAux.contatti);

            this.parametri = parametriAux
        },
        visAllegato(item, tipo){

            //maialata
            let path = this.parametri[item];
            window.open(path, "_blank");

        },
        insertAllegato(item, tipo) {

            this.uploadModal.showPercent = false;
            this.uploadModal.descrCaricamento = '';
            this.uploadModal.percentCaricamento = 0;
            this.uploadModal.errorCaricamento = '';
            this.uploadModal.show = true;
            this.uploadModal.uuidv4 = uuidv4();

            this.uploadModal.item = item;
            this.uploadModal.tipo = tipo;

            this.$nextTick(() => {
                this.prepareUpload();
            });

        },
        caricaItem() {
            if (this.r.files.length == 0) {
                alert("Nessun file selezionato!");
            } else {
                this.r.opts.target = NAMESPACE + 'rest/upload.php?id=' + this.uploadModal.uuidv4 + '&tokenupload=' + TOKENUPLOAD;
                this.uploadModal.showPercent = true;
                this.r.upload();
            }
        },
        insert(item, value) {

                var json = JSON.stringify({
                    'value': value
                });

                var appdettaglio = this;

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/cral/' + item, json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                appdettaglio.setParametri(response.data.message)
                                this.dismissCountDown = this.dismissSecs;

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            },
            prepareUpload(){

                //non rimuovere serve per resettare l'oggetto a ogni caricamento
                //altrimenti carica i file duplicandoli
                this.r = new Resumable({
                    target: '',
                    testChunks: true
                });

                this.r.assignBrowse(this.$refs.browse, false);

                var rg = this.r;
                var appdettaglio = this;



                    this.r.on('fileAdded', function(file, event) {
                        rg.files = rg.files.slice(-1); //prendo sempre solo l'ultimo file

                        //ATTENZIONE: non cambiare è come se fosse una funzione esterna e quindi il this qui non funzionerebbe
                        appdettaglio.uploadModal.descrCaricamento = file.fileName;

                    });

                    this.r.on('fileSuccess', function(file, message) {
                        try {
                            var res = JSON.parse(message.trim());

                            if (!res.error) {
                                appdettaglio.uploadModal.percentCaricamento = 100;

                                var json = JSON.stringify({
                                    'id': null,
                                    'id_scheda': 0,
                                    'tipo': appdettaglio.uploadModal.tipo,
                                    's3': res.message.s3,
                                    'allegato': encodeURI(appdettaglio.uploadModal.uuidv4 + '/' + file.fileName)
                                });

                                var token = localStorage.getItem('token');
                                appdettaglio.axios.post(NAMESPACE + 'rest/allegato', json, {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': token
                                        }
                                    })
                                    .then(response => {

                                        // JSON responses are automatically parsed.
                                        try {

                                            if (!response.data.error) {

                                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                                var res = response.data.message;
                                                if (res.length > 0) {
                                                    appdettaglio.insert(appdettaglio.uploadModal.item, res[0].id);
                                                    setTimeout(function() {
                                                        appdettaglio.uploadModal.show = false;
                                                    }, 1000);

                                                } else {
                                                    throw new Error("Errore dati file caricato non trovati!");
                                                }


                                            } else {
                                                throw new Error(response.data.message);
                                            }


                                        } catch (e) {
                                            throw new Error(e.message);
                                        }

                                    })
                                    .catch(e => {
                                        throw new Error((e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                                    });

                            } else {
                                throw new Error(res.message);
                            }

                        } catch (e) {
                            appdettaglio.uploadModal.errorCaricamento = "Errore: " + e.message;
                        }

                    });

                    this.r.on('progress', function() {
                        appdettaglio.uploadModal.percentCaricamento = rg.progress() * 100;
                        //alert("Perc car " + appdettaglio.uploadModal.percentCaricamento);
                        //FORZATURA NON BELLA
                        if (rg.progress() * 100 === 100) {
                            setTimeout(function() {
                                appdettaglio.uploadModal.show = false;
                            }, 1000);
                        }


                    });

                    this.r.on('error', function(message, file) {
                        appdettaglio.uploadModal.errorCaricamento = message;
                        //alert("Errore message " + message);
                        //alert("Errore file " + file);
                    });



            }


    },
    created: function () {

                if(!ctrlVismenu("M")){
                    this.$router.replace('/accessdenied');
                    return;
                }

                var token = localStorage.getItem('token');
                var appdettaglio = this;

                this.axios.get(NAMESPACE + 'rest/cral', {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                appdettaglio.setParametri(response.data.message)
                                appdettaglio.showdettaglio = true;

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

    },
    mounted: function() {



    }

}
</script>
